import { render, staticRenderFns } from "./userMiningRewards.vue?vue&type=template&id=5f82545e&scoped=true&"
import script from "./userMiningRewards.vue?vue&type=script&lang=js&"
export * from "./userMiningRewards.vue?vue&type=script&lang=js&"
import style0 from "./userMiningRewards.vue?vue&type=style&index=0&id=5f82545e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82545e",
  null
  
)

export default component.exports